// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3WCE7","inputDescription":"styles_inputDescription__1Oiff"};